import { AdminClientStream } from './AdminClientStream';

export default AdminClientStream;